import { observer } from '@rehaje/reactive-react'
import { uid } from '@rehaje/shared'

import { WidgetModel, WidgetNode } from '../models'

import type { FormWidget } from '../types'
import type { RehajePlugin, TypedSpecific } from '@rehaje/core'

/**
 * 创建挂件插件
 * @param type
 * @param component
 * @returns
 */
export const createWidgetPlugin = (
  type: string,
  component: FormWidget,
  prefix = 'Widget.'
): RehajePlugin => {
  return {
    component,
    visitors: {
      components: {
        [`${prefix}${type}`]: observer(({ model }) => model?.render())
      },
      models: {
        [`${prefix}${type}`]: class extends WidgetModel {}
      },
      nodes: {
        [`${prefix}${type}`]: class extends WidgetNode {
          constructor(specific: TypedSpecific) {
            specific.id ??= `__r_widget_${type}_${uid()}`
            super(specific)
          }
        }
      }
    }
  }
}
